/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/api';

import { API_BASE_URL } from '..';

import {
  CreatAnswersData,
  EditAnswersData,
  ListAnswersParams,
  AnswerReplayDateResponse,
  AnswerSyntheticResponse,
  AnswerCustomer,
  AnswerCustomerQuestionResponse,
} from './Answers.types';

const controller = 'answers';
const baseUrl = `${API_BASE_URL}/${controller}`;

export async function listAnswersReplyDate(
  quizId: number,
  params?: ListAnswersParams,
) {
  const result = (await api.get(
    `${baseUrl}/${quizId}/reply-date`,
    params,
  )) as unknown;

  return result as AnswerReplayDateResponse[];
}

export async function listAnswersSyntheticResearch(
  quizId: number,
  params?: ListAnswersParams,
) {
  const result = (await api.get(
    `${baseUrl}/${quizId}/synthetic-research`,
    params,
  )) as unknown;

  return result as AnswerSyntheticResponse;
}

export async function createAnswers(data: CreatAnswersData) {
  const result = (await api.post(baseUrl, data, null)) as unknown;

  return result as any;
}

export async function detailAnswers(questionId: number) {
  const result = (await api.get(`${baseUrl}/${questionId}`, null)) as unknown;

  return result as any;
}

export async function editAnswers(questionId: number, data: EditAnswersData) {
  const result = (await api.put(
    `${baseUrl}/${questionId}`,
    data,
    null,
  )) as unknown;

  return result as any;
}

export async function removeAnswers(questionId: number) {
  const result = (await api.remove(
    `${baseUrl}/${questionId}`,
    {},
    null,
  )) as unknown;

  return result as any;
}

export async function listAnswersCustomers(
  quizId: number,
  params?: ListAnswersParams,
) {
  const result = (await api.get(
    `${baseUrl}/${quizId}/reply-date/customers`,
    params,
  )) as unknown;

  return result as AnswerCustomer[];
}

export async function detailAnswersCustomers(
  query: {
    quizId: number;
    customerId?: number;
  },
  params?: ListAnswersParams,
) {
  const result = (await api.get(
    `${baseUrl}/${query.quizId}/reply-date/${query.customerId}`,
    params,
  )) as unknown;

  return result as AnswerCustomerQuestionResponse[];
}
